import React from 'react';

import PropTypes from 'prop-types';

import {
    Avatar,
    Grid,
    GridItem,
    List,
    ListAdornment,
    ListBody,
    ListItem,
    PinIcon,
    Typography,
} from 'wanderu-components';

import styles from './StationsList.scss';

function StationsList({ stations = [], stationsSubtitle }) {
    if (!stations.length) {
        return null;
    }

    return (
        <>
            <Typography
                className={styles.otherSubtitle}
                component="h4"
                variant="h6"
            >
                {stationsSubtitle}
            </Typography>
            <Grid
                columnSpacing={6}
                columns={2}
                component={List}
                rowSpacing={0}
            >
                {stations.map(({ name }) => (
                    <GridItem
                        component={ListItem}
                        key={name}
                        sm={1}
                        xs={2}
                    >
                        <ListAdornment aria-hidden>
                            <Avatar variant="square">
                                <PinIcon />
                            </Avatar>
                        </ListAdornment>
                        <ListBody component={Typography}>
                            {name}
                        </ListBody>
                    </GridItem>
                ))}
            </Grid>
        </>
    );
}

StationsList.propTypes = {
    stations: PropTypes.arrayOf(PropTypes.object),
    stationsSubtitle: PropTypes.string,
};

export default StationsList;
